export interface SizeChartData {
  [key: string]: {
    [subKey: string]: any;
  };
}

export const isValidChartData = (data: any): data is SizeChartData => {
  if (!data || typeof data !== "object") return false;
  if (data === null) return false;

  if (Array.isArray(data) && data.length === 0) return false;

  if (typeof data === "object" && Object.keys(data).length === 0) return false;

  try {
    const hasValidData = Object.values(data).some((value: any) => {
      if (value && typeof value === "object" && !Array.isArray(value)) {
        const subKeys = Object.keys(value);
        if (subKeys.length === 0) return false;

        return Object.values(value).some((subValue: any) => {
          return subValue !== null && subValue !== undefined && subValue !== "" && !(typeof subValue === "object" && Object.keys(subValue).length === 0);
        });
      }
      return false;
    });

    return hasValidData;
  } catch (error) {
    console.warn("Error validating chart data:", error);
    return false;
  }
};

export const isValidApiResponse = (response: any): boolean => {
  if (!response || typeof response !== "object") return false;
  if (!response.ok) return false;
  if (!response.data) return false;

  return isValidChartData(response.data);
};

export const extractChartData = (response: any): SizeChartData | null => {
  if (isValidApiResponse(response)) {
    return response.data;
  }
  return null;
};
